import styled from '@emotion/styled'
import { css } from '@emotion/react'
import PropTypes from 'prop-types'
import cn from 'classnames'

import Actions from 'components/App/DesktopView/shared/Composer/Header/Actions'
import CloseIcon from 'components/App/DesktopView/shared/Composer/CloseIcon'

import { Flex } from 'shared/ui'
import RecipientsEditor from './RecipientsEditor'
import withEditMode from './withEditMode'
import Label from './Label'
import Row from './Row'
import PinIcon from './PinIcon'

const ToRow = ({
  bccVisible,
  ccVisible,
  children, // e.g. FormSwitcherButton
  className,
  closeTo,
  editing,
  fromVisible,
  onActionClick,
  subjectVisible,
  ticketId,
  onUpdate,
  ...rest
}) => {
  return (
    <Row first className={className}>
      {children}
      <Flex
        className={cn(
          'toEditor grui items-baseline',
          { 'grui ml-4': !!children },
          { 'grui ml-0': !children }
        )}
        css={css`
          min-width: 0;
          flex: 1 1 60%;
        `}
      >
        <Label>To:</Label>
        <RecipientsEditor
          key={`recipientseditor-to-${ticketId}`}
          className="grui ml-3"
          type="to"
          ticketId={ticketId}
          onUpdate={onUpdate}
          {...rest}
        />
      </Flex>
      <Flex className={cn('grui', { 'mr-10': closeTo }, 'actions self-end')}>
        <Actions
          hideBcc={bccVisible}
          hideCc={ccVisible}
          hideFrom={fromVisible}
          hideSubject={subjectVisible}
          onClick={onActionClick}
        />
      </Flex>
      <PinIcon />
      {closeTo && <CloseIcon to={closeTo} />}
    </Row>
  )
}

ToRow.propTypes = {
  onActionClick: PropTypes.func.isRequired,
  closeTo: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  recipientsOpenUpward: PropTypes.bool,
}

ToRow.defaultProps = {
  closeTo: undefined,
  recipientsOpenUpward: false,
}

export default styled(withEditMode(ToRow))`
  . label {
    line-height: 24px; /* hacks around jumpy label as you remove recipient */
  }

  .actions {
    line-height: 2.67;
  }
`
